<template>
    <div id="personas" ref="personas" class="container-fluid">
        <div class="row" v-for="(persona, index) in personas">
            <div class="col">
                <div class="card card-body mb-4">
                    <h5 class="card-title">Persona {{index+1}} "{{firstword(persona)}}"</h5>
                    <p class="lead">{{persona}}</p>
                </div>
            </div>
        </div>
    </div>    
</template>
<script>
import axios from "axios";
export default {
  name: "app",
  props: {
    passedData: {
      type: String,
      default() {
        return "Dataset";
      },
    },
  },
  data() {
    return {
      testDataElem: null,
      personas: []
    };
  },
  methods: {
    firstword(textblock) {
        var thefirstword = textblock.split(" ")[0];
        return thefirstword
    }
  },
  mounted() {
    const reportName = this.passedData;
    axios
      .get("/get_personas", {
        params: { report: reportName },
      })
      .then((response) => {
        this.personas = response.data;
        console.log('cur '+JSON.stringify(this.personas))
      });
  }
};
</script>